import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import MainArticleContent from '@components/vitals/ArticleMainContent';
import { BREAKPOINT } from '@constants';
import { Article } from '@contracts';
import ArticleAudioBox from './ArticleAudioBox';
import { HeaderItem } from './utils/helpers';

interface Props {
  article: Article;
  activeAudio: string;
  headers: HeaderItem[];
}

export default function ArticleBody({ article, activeAudio, headers }: Props) {
  return (
    <ArticleBodyContainer>
      {activeAudio && <ArticleAudioBox articleTitle={article.data.title} activeAudio={activeAudio} />}
      <TextContainer className="rich-text">
        <MainArticleContent articleBody={article.data.body} headers={headers} />
      </TextContainer>
    </ArticleBodyContainer>
  );
}

const ArticleBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const TextContainer = styled.div`
  height: auto;
  width: 100%;
  text-align: start;

  // TODO Remove when we don't have to override base.scss explicitly
  p {
    color: ${Colors.navyBlue};
  }
  .rich-text {
    p {
      text-transform: none;
      font-family: BrownStd;
      font-size: 18px;
      line-height: 140%;
      margin: 0 0 22px;
      color: ${Colors.navyBlue};
    }
    a {
      color: ${Colors.lilac};

      &:hover {
        text-decoration: underline;
      }
    }

    h1 {
      font-family: Domaine;
      margin: 0 0 18px;
      font-weight: 600;
      line-height: 140%;
      letter-spacing: -0.24px;
      color: ${Colors.navyBlue};
      font-size: 30px;
    }
    h2,
    h4 {
      font-family: Domaine;
      margin: 0 0 18px;
      font-weight: 600;
      line-height: 140%;
      letter-spacing: -0.24px;
      color: ${Colors.navyBlue};
      font-size: 24px;
    }
    h3,
    h5 {
      font-family: Domaine;
      margin: 0 0 18px;
      line-height: 140%;
      font-weight: 600;
      color: ${Colors.navyBlue};
      font-size: 20px;
    }
    ul li {
      font-family: BrownStd;
      color: ${Colors.navyBlue};
      line-height: 140%;
      margin: 0 0 22px;
      font-size: 18px;
    }
    li {
      color: ${Colors.navyBlue};
    }
  }

  @media only screen and (max-width: ${BREAKPOINT.tablet}px) {
    .rich-text {
      p {
        font-size: 16px;
      }
      a {
        font-size: 16px;

        &:hover {
          text-decoration: underline;
        }
      }
      h1 {
        font-size: 26px;
      }
      h2,
      h4 {
        font-size: 24px;
      }
      h3,
      h5 {
        font-size: 20px;
      }
      ul li {
        font-size: 16px;
      }
    }
  }
`;
